import { z } from "zod";

export const CreateEmployeeSchema = z.object({
  name: z
    .string()
    .min(1, { message: "O nome é obrigatório." })
    .max(255, { message: "O nome não pode exceder 255 caracteres." }),

  phone: z.string().min(1, { message: "O telefone é obrigatório." }),

  email: z.string().email({ message: "Informe um e-mail válido." }),

  salon_id: z.string().min(1, { message: "Selecione um salão." }),

  user_id: z.string().min(1, { message: "Selecione um usuário." }),

  active: z.boolean(),

  vocation_ids: z
    .array(z.string())
    .min(1, "Selecione pelo menos uma profissão"),
});

export const UpdateEmployeeSchema = CreateEmployeeSchema.extend({
  id: z.string().uuid({ message: "ID inválido." }),

  created_at: z.string().optional(),
  updated_at: z.string().optional().nullable(),
  deleted_at: z.string().optional().nullable(),
});

export type CreateEmployeeData = z.infer<typeof CreateEmployeeSchema>;
export type UpdateEmployeeData = z.infer<typeof UpdateEmployeeSchema>;
